import { render, staticRenderFns } from "./decision-left.vue?vue&type=template&id=49b3783c&scoped=true&"
import script from "./decision-left.vue?vue&type=script&lang=ts&"
export * from "./decision-left.vue?vue&type=script&lang=ts&"
import style0 from "./decision-left.vue?vue&type=style&index=0&id=49b3783c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3783c",
  null
  
)

export default component.exports